import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api/axiosInstance';
import { toast } from 'sonner';

const thunk = (name, fn, showToast = true) =>
  createAsyncThunk(name, async (arg, { rejectWithValue }) => {
    try { return await fn(arg); }
    catch (err) {
      if (showToast) {
      toast.error(err.response?.data?.message || err.message || 'Request failed');
      }
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  });

export const fetchBatches = thunk('batch/fetchAll', async (params = {}) => {
  const { data } = await api.get('Batches', { params });
  return data.data;
});

export const fetchBatchById = thunk('batch/fetchById', async (id) => {
  const { data } = await api.get(`Batches/${id}`);
  return data.data;
});

export const createBatch = thunk('batch/create', async (dto) => {
  const { data } = await api.post('Batches', dto);
  toast.success('Batch created successfully');
  return data.data;
});

export const updateBatchStatus = thunk('batch/updateStatus', async ({ id, status }) => {
  await api.patch(`Batches/${id}/status?status=${status}`);
  toast.success('Batch status updated');
  return { id, status };
});

export const fetchBatchProgress = thunk('batch/progress', async (id) => {
  const { data } = await api.get(`Batches/${id}/progress`);
  return data.data;
},false);

const batchSlice = createSlice({
  name: 'batch',
  initialState: {
    items: [], totalCount: 0,
    selected: null, progress: null,
    loading: false, actionLoading: false, error: null,
  },
  reducers: {
    clearSelected: (s) => { s.selected = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBatches.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(fetchBatches.fulfilled, (s, a) => {
        s.loading = false;
        s.items = a.payload?.items || [];
        s.totalCount = a.payload?.totalCount || 0;
      })
      .addCase(fetchBatches.rejected, (s, a) => { s.loading = false; s.error = a.payload; })
      .addCase(fetchBatchById.pending, (s) => { s.actionLoading = true; })
      .addCase(fetchBatchById.fulfilled, (s, a) => { s.actionLoading = false; s.selected = a.payload; })
      .addCase(fetchBatchById.rejected, (s) => { s.actionLoading = false; })
      .addCase(createBatch.pending, (s) => { s.actionLoading = true; })
      .addCase(createBatch.fulfilled, (s, a) => {
        s.actionLoading = false;
        s.items = [a.payload, ...s.items];
        s.totalCount += 1;
      })
      .addCase(createBatch.rejected, (s) => { s.actionLoading = false; })
      .addCase(updateBatchStatus.fulfilled, (s, a) => {
        s.items = s.items.map((i) =>
          i.batchId === a.payload.id ? { ...i, status: a.payload.status } : i
        );
        if (s.selected?.batchId === a.payload.id) {
          s.selected = { ...s.selected, status: a.payload.status };
        }
      })
      .addCase(fetchBatchProgress.fulfilled, (s, a) => { s.progress = a.payload; });
  },
});

export const { clearSelected } = batchSlice.actions;
export default batchSlice.reducer;